import { ApiService, Category } from "@/libs";
import { DataService } from "@/service";
export class CommonService {
	/**
	 * 批量在指定的目录下删除数据
	 * @param dataArr
	 * @param dirId
	 * @returns
	 */
	static async delete(dataArr: any, dirId: number, dirCategoryId: number, categoryId: number) {
		let url = `${ApiService.JrzzApi}/data/${dirCategoryId}/${categoryId}/batchdelete?dirId=${dirId}&trueDelete=true`;
		let result = await DataService.post(url, dataArr);
		try {
			return result;
		} catch (error) {}
	}

	static async add(dirCategoryId: number, categoryId: number, dirId: number, entity: any) {
		let url = `${ApiService.JrzzApi}/data/${dirCategoryId}/${categoryId}/add?dirId=${dirId}`;
		console.log(entity);
		return await DataService.post(url, entity);
	}
	static async dataDelete(dirCategoryId: number, categoryId: number, dirId: number, dataId: number) {
		let url = `${ApiService.JrzzApi}/data/${dirCategoryId}/${categoryId}/delete?dirId=${dirId}&dataId=${dataId}&trueDelete=true`;
		return await DataService.post(url);
	}

	static async authUploadFiles(data: { files: any[] }) {
		return await DataService.post(`${ApiService.EngineerApi}/fileUpload/authUploadFiles`, data);
	}
}
